export { getCookie } from './get-cookie.js';
